import { toArray } from 'lodash';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel } from 'client/data/models/vehicle';
import { Select } from 'site-modules/shared/components/select/select';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { sortByYear } from 'site-modules/shared/utils/sorting';
import { filterPubStates, isPreProd } from 'site-modules/shared/utils/publication-states';
import { PUB_STATES_NEW, PUB_STATES_USED } from 'client/constants/pub-states';
import { DEFAULT_CLASSNAMES } from './constants';

const stateToPropsConfig = {
  options: bindToPath(
    props => {
      const { make, model, submodel } = props;
      return make && submodel && `makes["${make.slug}"].models["${model.slug}"].submodels["${submodel.slug}"].years`;
    },
    VehicleModel,
    yearData => {
      const yearDataArr = toArray(yearData).sort(sortByYear);
      const options = [];
      const allNewVehicles = filterPubStates(yearDataArr, PUB_STATES_NEW);
      const newVehicleNotPreProd = allNewVehicles.filter(vehicleData => !isPreProd(vehicleData.pubStates));
      const usedVehicles = filterPubStates(yearDataArr, PUB_STATES_USED);

      if (newVehicleNotPreProd.length) {
        options.push({ ...newVehicleNotPreProd[0], pubstate: 'NEW' });
      }
      if (usedVehicles.length) {
        options.push({ ...usedVehicles[0], pubstate: 'USED' });
      }

      return options;
    }
  ),
};

export const PubStateDropdown = connectToModel(Select, stateToPropsConfig);

export const StyledPubStateDropdown = connectToModel(StyledSelect, stateToPropsConfig);

const DEFAULT_PROPS = {
  name: 'select-pubstate',
  toggle: 'Select NEW / USED',
  valueKey: 'pubstate',
  labelKey: 'pubstate',
};

PubStateDropdown.defaultProps = { ...DEFAULT_PROPS, className: `js-pubstates-select ${DEFAULT_CLASSNAMES}` };

StyledPubStateDropdown.defaultProps = DEFAULT_PROPS;
